// Export all skeleton components for easier imports
export * from './HeaderSkeleton';
export * from './LayoutSkeleton';
export * from './StudentSkeleton';
export * from './StudentProfileSkeleton';
export * from './GradesSkeleton';
export * from './GradeStudentsSkeleton';
export * from './SupportingStaffDetailSkeleton';
export * from './StaffDetailSkeleton';
// Add imports for other skeleton components
export * from './DataTableSkeleton';
export * from './SearchBarAndFiltersSkeleton';
export * from './PaginationSkeleton';
export { WelcomeMessageSkeleton } from './WelcomeMessageSkeleton';
export * from './TransportationPageSkeleton';
export { TransportationFormSkeleton } from './TransportationFormSkeleton';
export * from './ReceiptsPageSkeleton';
export * from './PendingFeesPageSkeleton';
export * from './GenerateReportPageSkeleton';
export * from './SystemReportPageSkeleton';
export * from './BiometricSettingsSkeleton';
export * from './SearchResultsSkeleton';
// Tab-specific skeleton components
export * from './TabContentSkeleton';
export * from './PersonalTabSkeleton';
export * from './AttendanceTabSkeleton';
export * from './GradeAttendanceTabSkeleton';
export * from './TransportTabSkeleton';
export * from './DocumentsTabSkeleton';
export * from './DisciplineTabSkeleton';
export * from './FeesTabSkeleton';
export * from './AttendanceClientSkeleton';
export * from './NavbarSkeleton';
export * from './TopNavbarSkeleton';

// Form-specific skeleton components
export * from './AddStudentFormSkeleton';
export * from './StaffFormSkeleton';
export * from './FeeConfigurationSkeleton';
export * from './LoginSkeleton';
export * from './VehicleDetailsSkeleton';
export * from './ShiftManagementSkeleton';
